var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-4"},[(_vm.queueText)?_c('v-layout',{attrs:{"mt-3":""}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.queueText)}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }